import { TaxiCorporationCargoTaxiContractListItem } from "../../../../../../common/services/taxi-corporation/cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list";
import TaxiCargoContractListingItem from "../types/taxi-cargo-contract-listing-item";

const createListingItem = (
  responseDataItem: TaxiCorporationCargoTaxiContractListItem,
): TaxiCargoContractListingItem => {
  return {
    uuid: responseDataItem.id,
    billingModel: responseDataItem.model,
    cargoCompany: responseDataItem.cargoCompany.companyName,
    discountPercentLimit: responseDataItem.discountLimit,
    distanceRate: responseDataItem.distanceRate,
    freeStoppingPeriodMinutes: responseDataItem.haltingTimeAfterMinutes,
    isActive: !responseDataItem.disabled,
    isTollRoadsDuringOrderAllowed: responseDataItem.allowChargeDuringRide,
    isTollRoadsWhileApproachingAllowed:
      responseDataItem.allowChargeWhileApproaching,
    isTollRoadsWhileReturningAllowed:
      responseDataItem.allowChargeWhileReturning,
    isOrderPublishingAllowed: responseDataItem.publishingAllowed,
    stoppingRate: responseDataItem.haltingTimeRate,
    validFrom: new Date(responseDataItem.validSince),
    validTo: new Date(responseDataItem.validTo),
    contactPassengerAfterMinutes: responseDataItem.contactPassengerAfterMinutes,
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationCargoTaxiContractListItem[],
): TaxiCargoContractListingItem[] => {
  const results = responseDataItems.map(createListingItem);

  return results;
};

const taxiCargoContractListingFactory = { createListingItems };

export default taxiCargoContractListingFactory;
